import { ExtrasId } from '../enums';
export var CITYTAX_PACKAGE = 'CITYTAX';
export var CCUI_LOCALE_COOKIE = 'CCUI_LOCALE';
export var RESERVATION_STATUS = {
  CANCELLED: 'CANCELLED',
  UPCOMING: 'UPCOMING'
};
export var RESERVATION_SOURCE_PMS = {
  OPERA: 'OPERA',
  BART: 'BART'
};
export var PurposeOfStayAnalytics = {
  LEISURE: 'leisure',
  BUSINESS: 'business'
};
export var PI_FAVICON = '/content/dam/pi/websites/desktop/icons/favicons/favicon.ico';
export var MAX_NIGHTS_CCUI = 364;
export var AMEND_COOKIE_NAME = 'bb-amend';
export var AMEND_COOKIE_EXPIRY_MINUTES = 30;
export var BB_LIVE_ASSIST = '/etc/clientlibs/pi/resources/js/live-assist.js';
export var BB_CO_BROWSE = '/etc/clientlibs/pi/resources/js/co-browse.js';
export var LOCALES = function (LOCALES) {
  LOCALES["DE"] = "de-de";
  LOCALES["EN"] = "en-gb";
  return LOCALES;
}({});
export var FREE_FOOD_OPTIONS = {
  DINNER: 'dinner',
  BREAKFAST: 'breakfast'
};
export var DLP_AKAMAI_HEADER_NAME = 'Akamai-Cache';
export var DEFAULT_REDIS_TTL = 30 * 60;
export var CACHED_QUERIES_LIST = ['GetStaticContent', 'seoInformation'];
export var VALID_EXTRAS_IDS = [ExtrasId.EARLY_CHECK_IN, ExtrasId.EARLY_CHECK_IN_FREE, ExtrasId.LATE_CHECK_OUT, ExtrasId.LATE_CHECK_OUT_FREE, ExtrasId.ULTIMATE_WIFI, ExtrasId.ULTIMATE_WIFI_FREE, ExtrasId.BOTTLE_OF_PROSECCO];
export var EARLY_CHECKIN_IDS = [ExtrasId.EARLY_CHECK_IN, ExtrasId.EARLY_CHECK_IN_FREE];
export var LATE_CHECKOUT_IDS = [ExtrasId.LATE_CHECK_OUT, ExtrasId.LATE_CHECK_OUT_FREE];
export var WIFI_IDS = [ExtrasId.ULTIMATE_WIFI, ExtrasId.ULTIMATE_WIFI_FREE];
export var PROSECCO_IDS = [ExtrasId.BOTTLE_OF_PROSECCO];